@switch (timeline_item.card_type) {
    @case ('entry_search') {
        <app-tournament-search-card
            [card]="timeline_item"
            [aspect_ratio]="aspect_ratio"
            [attr.data-card-id]="timeline_item.context.uuid"
            [timeline_id]="timeline_id"
        ></app-tournament-search-card>
    }

    @case ('live_entries') {
        <app-live-entries></app-live-entries>
    }

    @case ('upcoming_entries') {
        <app-collection-entries [entry_type]="timeline_item.card_type"></app-collection-entries>
    }

    @case ('past_partner_entries') {
        <app-collection-entries [entry_type]="timeline_item.card_type"></app-collection-entries>
    }

    @case ('completed_entries') {
        <app-collection-entries [entry_type]="timeline_item.card_type"></app-collection-entries>
    }
}
